import { render, staticRenderFns } from "./SeconPassword.vue?vue&type=template&id=893a33fe&scoped=true&"
import script from "./SeconPassword.vue?vue&type=script&lang=js&"
export * from "./SeconPassword.vue?vue&type=script&lang=js&"
import style0 from "./SeconPassword.vue?vue&type=style&index=0&id=893a33fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893a33fe",
  null
  
)

export default component.exports